import { JSX, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { useLoading } from "../hooks/useLoading";

interface Props {
  children: JSX.Element;
}

// admin向けのRequireAuthとは別物。グループ本人向けポータル（/portal）用の
// 認証ガード。判定基準は「Firebase Authでログイン済みか」のみで、
// admin/judgeが使うusersコレクションの権限（role・judge）は見ない。
const RequirePortalAuth = ({ children }: Props) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  const { setIsLoading } = useLoading();

  useEffect(() => {
    setIsLoading(true);

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [setIsLoading]);

  if (isAuthenticated === null) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace />;
  }

  return children;
};

export default RequirePortalAuth;
